// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__x001i","input-wrapper":"styles_input-wrapper__bWe7g","icon":"styles_icon__BD_3m"};